// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1MNeP","header":"header___2wv9f","renderNotes":"renderNotes___-tIMj","renderMtls":"renderMtls___3qYnl","statsContainer":"statsContainer___3HDM2","stats":"stats___MHHoV","statsKey":"statsKey___2u1Jf","statsDivider":"statsDivider___2fChU","statsValue":"statsValue___3nrwl","actionContainer":"actionContainer___35fF0","displayType":"displayType___QxBi3","closeIcon":"closeIcon___32lFf","btnGroup":"btnGroup___obmE3","text":"text___iRb9V"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RenderView/RenderView.module.css
// module id = 409
// module chunks = 0